module.exports = __webpack_public_path__ + "static/media/duration.ad8bf7ba.png";